var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHamburguesa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_26_54",
    "data-name": "Componente 26 \\u2013 54",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_243",
    "data-name": "Trazado 243",
    d: "M0,0H36V36H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_22",
    "data-name": "L\\xEDnea 22",
    x2: 27.885,
    transform: "translate(4 8.601)",
    fill: "none",
    stroke: "#d4b68e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_23",
    "data-name": "L\\xEDnea 23",
    x2: 27.654,
    transform: "translate(4 18)",
    fill: "none",
    stroke: "#d4b68e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_24",
    "data-name": "L\\xEDnea 24",
    x2: 27.885,
    transform: "translate(4 27.235)",
    fill: "none",
    stroke: "#d4b68e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHamburguesa);
export default __webpack_public_path__ + "static/media/menu_hamburguesa.be44abb69ea33fdca3c86367717c6078.svg";
export { ForwardRef as ReactComponent };